export interface IAdminTeamResult {
  clubId: number;
  eventId: number;
  flightId: number;
  groupId: number;
  roundId: number;
  roundOrder: number;
  seasonId: number;
  teamGameId: number;
  teamId: number;
  teamName: string;
  cut?: boolean;
  teamStrokeBetterballGrossAuxScore: number;
  teamStrokeBetterballGrossPosition: number;
  teamStrokeBetterballGrossScore: number;
  teamStrokeBetterballGrossTie: boolean;
  teamStrokeBetterballNetAuxScore: number;
  teamStrokeBetterballNetPosition: number;
  teamStrokeBetterballNetScore: number;
  teamStrokeBetterballNetTie: boolean;
  teamStrokeTotalGrossAuxScore: number;
  teamStrokeTotalGrossPosition: number;
  teamStrokeTotalGrossScore: number;
  teamStrokeTotalGrossTie: boolean;
  teamStrokeTotalNetAuxScore: number;
  teamStrokeTotalNetPosition: number;
  teamStrokeTotalNetScore: number;
  teamStrokeTotalNetTie: boolean;
  text: string | null;
  through: number;
}

export interface IAdminTeamResultsStore {
  [roundId: string]: { [flightId: string]: IAdminTeamResult[] };
}

export const adminTeamResultsStore: IAdminTeamResultsStore = {};
